import SalesLayout from './SalesLayout';

export default SalesLayout;